/* ============================================================
   Critter Foundry — global.js
   Cart drawer (Ajax Cart API + Section Rendering API), qty
   steppers, free-shipping nudge, mobile menu. No framework.
   ============================================================ */
(function () {
  'use strict';

  var CF = window.CritterFoundry || {};
  var routes = CF.routes || {};
  var SECTION = 'cart-drawer';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Cart drawer open / close ---------- */
  function drawer() { return document.getElementById('CartDrawer'); }
  function scrim() { return document.getElementById('CartScrim'); }

  function openDrawer() {
    var d = drawer(), s = scrim();
    if (!d || !s) return;
    s.hidden = false;
    // allow the element to paint before transitioning
    requestAnimationFrame(function () {
      d.classList.add('is-open');
      s.classList.add('is-open');
    });
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = $('.cart-drawer__close', d);
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    var d = drawer(), s = scrim();
    if (!d || !s) return;
    d.classList.remove('is-open');
    s.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    window.setTimeout(function () { s.hidden = true; }, 280);
  }

  /* ---------- Render cart from a fetched section ---------- */
  function replaceDrawerContents(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.getElementById('CartDrawer');
    var current = drawer();
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
    }
  }

  function updateCartCounts(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (count === null) return;
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  /* ---------- Section Rendering API helpers ---------- */
  function refreshDrawer() {
    return fetch(routes.cart_url + '?sections=' + SECTION, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data[SECTION]) replaceDrawerContents(data[SECTION]);
      });
  }

  function syncCount() {
    return fetch(routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(updateCartCounts);
  }

  /* ---------- Ajax actions ---------- */
  function addToCart(form) {
    var formData = new FormData(form);
    formData.append('sections', SECTION);
    formData.append('sections_url', window.location.pathname);

    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }

    return fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { // error (e.g. sold out)
          if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = btn.dataset.label || 'Add to cart'; }
          announce(data.description || data.message || 'Could not add to cart.');
          return;
        }
        if (data.sections && data.sections[SECTION]) {
          replaceDrawerContents(data.sections[SECTION]);
        } else {
          refreshDrawer();
        }
        if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = btn.dataset.label || 'Add to cart'; }
        syncCount();
        openDrawer();
      })
      .catch(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = btn.dataset.label || 'Add to cart'; }
      });
  }

  function changeLine(line, quantity) {
    return fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: SECTION, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.sections && cart.sections[SECTION]) {
          replaceDrawerContents(cart.sections[SECTION]);
        } else {
          refreshDrawer();
        }
        updateCartCounts(cart);
      });
  }

  var live;
  function announce(msg) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = msg;
  }

  /* ---------- Event delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    // open drawer
    var opener = t.closest('[data-cart-toggle]');
    if (opener) { e.preventDefault(); refreshDrawer().then(openDrawer); return; }

    // close drawer
    if (t.closest('[data-cart-close]') || t.id === 'CartScrim') { e.preventDefault(); closeDrawer(); return; }

    // mobile menu
    var menuBtn = t.closest('[data-menu-toggle]');
    if (menuBtn) {
      var nav = document.getElementById('SiteNav');
      if (nav) {
        var open = nav.classList.toggle('is-open');
        menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    // PDP thumbnail swap
    var thumb = t.closest('[data-thumb]');
    if (thumb) {
      var main = document.getElementById('PdpMainImage');
      var mainImg = main && main.querySelector('img');
      if (mainImg && thumb.dataset.full) {
        mainImg.src = thumb.dataset.full;
        mainImg.removeAttribute('srcset');
      }
      return;
    }

    // cart line remove
    var remove = t.closest('[data-line-remove]');
    if (remove) { e.preventDefault(); changeLine(parseInt(remove.dataset.lineRemove, 10), 0); return; }

    // qty steppers (PDP + cart line)
    var step = t.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var wrap = step.closest('.qty');
      var input = $('input', wrap);
      var dir = parseInt(step.dataset.qtyStep, 10);
      var min = input && input.min ? parseInt(input.min, 10) : 1;
      var current = parseInt((input && input.value) || '1', 10) || min;
      var next = Math.max(min, current + dir);
      if (input) input.value = next;
      var lineIndex = step.dataset.line;
      if (lineIndex) {
        changeLine(parseInt(lineIndex, 10), next); // cart line
      } else {
        syncQty(step.closest('form'), next); // PDP — keep both bars + hidden source in sync
      }
    }
  });

  // Keep all PDP quantity inputs (+ the submitted hidden source) in sync
  function syncQty(form, value) {
    if (!form) return;
    $all('[data-qty-input]', form).forEach(function (i) { i.value = value; });
    var source = form.querySelector('[data-qty-source]');
    if (source) source.value = value;
  }

  // add-to-cart forms
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.product-form');
    if (form) { e.preventDefault(); addToCart(form); }
  });

  // Esc closes the drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // direct edits to a cart line qty input
  document.addEventListener('change', function (e) {
    var lineInput = e.target.closest('[data-line-qty]');
    if (lineInput) {
      var qty = Math.max(0, parseInt(lineInput.value, 10) || 0);
      changeLine(parseInt(lineInput.dataset.lineQty, 10), qty);
      return;
    }
    // direct typing in a PDP quantity field
    var pdpInput = e.target.closest('[data-qty-input]');
    if (pdpInput) {
      var v = Math.max(1, parseInt(pdpInput.value, 10) || 1);
      syncQty(pdpInput.closest('form'), v);
    }
  });
})();
